<template>
  <div :class="{ 'cellEditable': canEditPrice }">
        <span @click="priceValueClicked"
              v-if="!priceEditMode">
          {{ formatNumber(service.pivot.price_original, true) }} {{ currencyName }}
        </span>
    <input v-if="priceEditMode"
           min="0"
           v-click-outside="priceValueClickOutside"
           ref="priceEditRef"
           @keyup.enter="priceValueClickOutside"
           @keyup.esc="cancelPriceEdit"
           @keyup="$event.target.value < 0 ? service.pivot.price_original = 0 : ''"
           class="form-control sm d-inline-block align-middle"
           v-model="service.pivot.price_original"
           type="number"/>
  </div>
</template>

<script setup>
import {computed, inject, nextTick, ref, watch} from "vue"
import { formatNumber } from "@/extensions/filters/filters"
import {useStore} from "vuex"

const props = defineProps({
  service: Object,
  readonly: Boolean,
  teeth: Array,
})

const store = useStore()

const versionCount = inject('versionCount')

const priceEditMode = ref(false)
const justOpened = ref(false)
const priceEditRef = ref(null)
const originalValue = ref(0)

const currencyName = computed(() => store.getters.getCurrencyName)
const canEditPrice = computed(() => props.service.price_can_be_changed && !props.readonly)

const processJustOpened = () => {
  justOpened.value = true
  setTimeout(() => justOpened.value = false, 100)
}

const priceValueClickOutside = () => {
  if(justOpened.value) return
  priceEditMode.value = false
}

const priceValueClicked = async () => {
  if(!canEditPrice.value) return
  priceEditMode.value = true
  // discountValueEditMode.value = false
  // discountTypeEditMode.value = false
  processJustOpened()
  await nextTick()
  originalValue.value = props.service.pivot.price_original
  priceEditRef.value?.focus()
}

const cancelPriceEdit = () => {
  props.service.pivot.price_original = originalValue.value
  priceEditMode.value = false
}

const changeAllServicesParam = (paramName, value) => {
  props.teeth.forEach((tooth) => {
    tooth.services.forEach(service => {
      if(service.id === props.service.id) {
        service.pivot[paramName] = value
      }
    })
  })
  versionCount.value++
}

watch(() => props.service.pivot.price_original, (val) => {
  changeAllServicesParam('price_original', val)
})
</script>
